import React, { FC, ReactNode } from 'react';
import { ActivityIndicator } from '@kontentino/ui';

type Props = {
  children: string | ReactNode | ReactNode[];
};

const PopupLoading: FC<Props> = (props) => {
  return (
    <div className="tw-flex tw-flex-col tw-items-center tw-justify-center">
      <ActivityIndicator className="tw-h-7 tw-w-7" />
      <div className="tw-mt-2">{props.children}</div>
    </div>
  );
};

export default PopupLoading;
